import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import authService from '../services/AuthService';
import { ROUTE_BACK_OFFICE_HOME } from '../../constants';

export const validateUser = createAsyncThunk(
  'auth/validateUser',
  async () => {
    const user = await authService.validateUser();
    return user;
  }
);

const initialState = {
  status: 'idle',
  error: null
};

const authSlice = createSlice({
  name: 'backOfficeAuth',
  initialState,
  reducers: {
    updateUser(state, action) {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateUser.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(validateUser.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.user = action.payload;
      })
      .addCase(validateUser.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export const { updateUser } = authSlice.actions;

export const loginUser = (credentials, navigate, onAuthResponse) => async (dispatch) => {
  try {
    const response = await authService.login(credentials);

    if (onAuthResponse && onAuthResponse(response)) {
      return response;
    }

    await dispatch(validateUser());
    navigate(ROUTE_BACK_OFFICE_HOME);
    return response;
  } catch (error) {
    console.error('Login failed:', error);
    throw error;
  }
};

export const verifyTwoFactor = (payload, navigate) => async (dispatch) => {
  try {
    const response = await authService.verifyTwoFactor(payload);
    await dispatch(validateUser());
    navigate(ROUTE_BACK_OFFICE_HOME);
    return response;
  } catch (error) {
    console.error('2FA Verification failed:', error);
    throw error;
  }
};

export const logoutUser = (navigate) => async () => {
  await authService.logout(navigate);
};

export default authSlice.reducer;